import { render, staticRenderFns } from "./DialogScroller.vue?vue&type=template&id=f0fa1da4&scoped=true&"
import script from "./DialogScroller.vue?vue&type=script&lang=babel&"
export * from "./DialogScroller.vue?vue&type=script&lang=babel&"
import style0 from "./DialogScroller.vue?vue&type=style&index=0&id=f0fa1da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fa1da4",
  null
  
)

export default component.exports